import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { SimplifiedSelectDateRange, H1, SmallOnly, Caret } from "commons";
import { isPrintMode, getDebugPrinter, getPdfPrinter, getUuid } from "commons/src/QueryParameter";
import { convertIdToReal } from "commons/src/NuDateUtils";

import { routes } from "../../helpers/RouteHelpers";
import { MainFrame } from "../../../../../transactions/src/MainFrame";

export function IncomeHistory({ history, accountNum, accounts, rangeId, theme }) {
    const handleSubmit = (accountNum, rangeId) =>
        history.push(routes.client.incomeHistory({ accountNum, rangeId }));

    const handleDateChange = (_e, dateSelection) => handleSubmit(accountNum, dateSelection.rangeId);

    const handleBack = () => window.history.back();

    const accountId = accounts?.[accountNum]?.accountId?.toString() ?? "default";

    const dateRange = convertIdToReal(rangeId);

    return (
        <ContentHolder>
            <SmallOnly>
                <ReturnHeader onClick={handleBack}>
                    <Caret direction="left" fontSize="large" />
                    Back
                </ReturnHeader>
            </SmallOnly>
            <H1>Income History</H1>
            <Container>
                <FlexList>
                    <SimplifiedSelectDateRange value={rangeId} dateChanged={handleDateChange} />
                </FlexList>
            </Container>

            <MainFrame
                accountId={accountId}
                dateSelection={dateRange}
                isClientPortal={true}
                isIncomeHistory={true}
                isPrintMode={isPrintMode()}
                printHost={getDebugPrinter(window.location)}
                pdfExporter={getPdfPrinter(window.location)}
                uuid={getUuid(window.location)}
                theme={theme}
            />
        </ContentHolder>
    );
}

const ContentHolder = styled.div`
    margin: 0 auto;
    padding: 1em;
    overflow: hidden;
`;

const FlexList = styled.div`
    display: flex;
    list-style-type: none;
    justify-content: center;
    align-items: center;

    @media (max-width: ${props => props.theme.maxWidth}) {
        flex-direction: column;
    }
`;

export const ReturnHeader = styled.a`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 10px;
`;

const Container = styled.div`
    margin: auto;
    @media (min-width: ${props => props.theme.minWidth}) {
        max-width: 860px;
    }
`;

IncomeHistory.defaultProps = {
    accounts: {}
};

IncomeHistory.propTypes = {
    accounts: PropTypes.object,
    accountNum: PropTypes.string,
    history: PropTypes.shape({
        push: PropTypes.func
    }),
    rangeId: PropTypes.string,
    theme: PropTypes.object
};
